import { render, staticRenderFns } from "./SuppliesComments.vue?vue&type=template&id=28d79112&"
import script from "./SuppliesComments.vue?vue&type=script&lang=ts&"
export * from "./SuppliesComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports